module.exports = __webpack_public_path__ + "img/greensuitman3.5d3ebca7.jpg";